<template>
  <div class="wrapper" >
    <div :class="['company',`${headerBgClass ? headerBgClass : ''}`].join(' ')" @click="showDeptPopup" v-if="!hide">
      <div class='left'>
        <div class="company-name" v-if="deptInfoData.deptName">{{deptInfoData.deptName}}</div>
        <div class="company-name-tips" v-else>请选择部门</div>
        <div class="drop-down">
          <i class="huisuiyunfont">&#xe737;</i>
          <!-- <van-icon name="arrow-down" /> -->
        </div>
      </div>
    </div>
    <van-popup v-model="showChangeDept" closeable @close ="closeDeptPopup" position="bottom" class="company-popup">
      <div class="wrap" style="position: relative">
        <div class="top">
          <div class="switch-title" @click="showChangeDept = true">请选择部门</div>
        </div>
        <div class="radio-wrap">
          <van-radio-group v-model="deptInfoData.deptId">
            <van-radio
              :name="item.deptId"
              class="company-item"
              v-for="(item) in deptList"
              :key="item.deptId"
              icon-size=".64rem"
              @click="selectDept(item)"
            >
              {{item.deptName}}
            </van-radio>
          </van-radio-group>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import {
  Popup,
  Radio,
  RadioGroup,
  Notify,
  Icon
} from 'vant'
import { invoiceRequest } from '@services'

export default {
  components: {
    [Popup.name]: Popup,
    [Radio.name]: Radio,
    [RadioGroup.name]: RadioGroup,
    [Notify.name]: Notify,
    [Icon.name]: Icon
  },
  props: {
    hide: {
      type: Boolean,
      default: false
    },
    headerBgClass: {
      type: String,
      default: ''
    },
    companyShow: {
      type: Boolean,
      default: false
    },
    visible: {
      type: Boolean,
      default: false
    },
    deptInfo: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      showChangeDept: false,
      deptList: [],
      deptInfoData: {}
    }
  },
  computed: {
  },
  watch: {
    deptInfo (v) {
      this.deptInfoData = v
    },
    visible (v) {
      this.showChangeDept = v
    }
  },
  created () {},
  mounted () {
    this.getUserDept()
    this.deptInfoData = this.deptInfo
  },
  activated () {},
  updated () {},
  methods: {
    showDeptPopup () {
      this.getUserDept()
      this.showChangeDept = true
    },
    closeDeptPopup () {
      this.showChangeDept = false
      this.$emit('onCloseDeptPopup')
    },
    async selectDept (item) {
      // this.deptInfo = item
      this.$emit('onSelectDept', item)
      // Observer.runFunction({ type: 'changeDept', params: item }) // 发布changeDept方法，注册了的方法都会执行
      this.closeDeptPopup()
    },
    async getUserDept () {
      const data = await invoiceRequest.customer.getUserDept({})
      if (data.success) {
        if (data.result.length) {
          this.deptList = data.result
          if (data.result.length === 1) {
            // this.deptInfo = data.result[0]
            this.$emit('onSelectDept', data.result[0])
          }
        } else {
          this.deptList = []
        }
      } else {
        Notify({ type: 'danger', message: data.message })
      }
    }
  }
}
</script>
<style scoped lang='less'>
.wrapper{
  height: 100%;
  max-height: 120px;
  .company{
    height: 100%;
    background: #fff;
    font-size: .68267rem;
    color: #3E4966;
    // font-weight: bold;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .left{
      width: 100% !important;
      display: flex;
      justify-content: space-between;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      .drop-down /deep/.van-icon-arrow-down::before{
        color: #3E4966;
        font-weight: bold;
      }
      .drop-down {
        i{
          font-size: 28px;
        }
      }
      .company-name{
        font-weight: bold;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        font-size: 30px;
      }
      .company-name-tips{
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        color: #9EA9B9;
        font-size: 26px;
      }
      .iconfont{
        margin-left: 10px;
        font-size: 20px;
        color: #2B2E37;
      }
    }
    .center-i{
      flex-grow: 1;
      text-align: left;
    }
    .right{
      height: 100%;
      display: flex;
      align-items: center;
      padding: 0 30px;
      .qrcode{
        font-size: 48px;
        // font-weight: 100 !important;
        color: #3E4966;
      }
    }
  }
  .red{
     background: #F5F5F5;
     font-size: 40px;
  }
  .blue{
    background-color: #3378FF;
    color: #fff;
    font-size: 40px;
    font-weight: 400;
    i{
      color: #fff !important;
    }
  }
  .company-popup {
    height: 50%;
    /deep/.van-popup__close-icon--top-right {
      top: 10px;
    }
    .wrap {
      height: 100%;
    }

    .top {
      position: absolute;
      width: 100%;
      height: 80px;
      background: #fff;
      z-index: 1;
      .switch-title {
        width: 100%;
        text-align: center;
        padding-top: 20px;
        font-size:34px;
        font-weight:bold;
        color:rgba(51,51,51,1);
      }
    }
    .search-wrp {
      /deep/.van-field__right-icon {
        font-size: 60px;
      }
      .search-input {
        height:60px;
        background:rgba(255,255,255,1);
        border:1PX solid rgba(201,201,201,1);
        border-radius:5px;
        font-size:26px;
        padding: 10px 20px;
      }
      .search-ipt {
        width: 90%;
        margin: 10px auto;
        padding: 10px 18px;
        font-size: 26px;
        font-weight: 400;
        border-radius: 5px;
        border: none;
        height: 40px;
        overflow: hidden;
        background: #fff;
        display: flex;
        justify-content: space-between;
        align-items: center;
        border: solid 1px gray;
        i {
          color: #999;
          font-size: 35px;
        }
        input {
          border: 0;
          height: 30px;
          vertical-align: center;
          width: calc(100% - 50px);
          color: rgba(0, 0, 0, 0.8);
          outline: none;
          &::placeholder {
            color: rgba(187, 186, 186, 1);
          }
        }
      }
    }
    .radio-wrap {
      height: calc(100% - 80px);
      padding-top: 80px;
      overflow: scroll;
    }
    /deep/.van-radio__icon {
      margin: 0 40px 0 30px;
    }
    .company-item {
      font-size:30px;
      font-weight:500;
      color:rgba(51,51,51,1);
      height: 100px;
    }
  }
}
</style>
